import {create} from 'zustand'

interface DisclaimerDialogState {
  activeId: string | undefined
  setActiveId: (name: string) => void
  unsetActiveID: () => void
}

export const useDisclaimerDialogStore = create<DisclaimerDialogState>()((set) => ({
  activeId: undefined,
  setActiveId: (id) => set(state => ({...state, activeId: id})),
  unsetActiveID: () => set(state => ({...state, activeId: undefined})),
}))
